<template>
  <div class="config">
    <div class="head-box c-m-b-15">
      <h4>移动端租户配置</h4>
    </div>
    <el-tabs tab-position="left">
      <el-tab-pane label="轮播图配置">
        <el-form label-width="80px" label-position="left" :model="formData">
          <el-card class="c-card" shadow="hover" v-for="(item, i) in formData.banners" :key="i">
            <div slot="header" class="c-card-header">
              <span class="c-w-500">#{{ i + 1 }}</span>
              <div>
                <el-button icon="el-icon-plus" type="primary" circle @click="add(i)"></el-button>
                <el-button
                  icon="el-icon-close"
                  type="danger"
                  circle
                  v-if="formData.banners.length > 1"
                  @click="remove(i)"
                ></el-button>
              </div>
            </div>
            <div class="c-flex c-flex-item">
              <el-form-item label-width="0" style="margin-bottom:0;">
                <el-upload
                  style="width:300px !important;margin-right:50px;"
                  :class="item.img ? '' : ''"
                  :action="upload.url"
                  :data="upload.data"
                  :file-list="upload.fileList"
                  list-type="picture-card"
                  :show-file-list="false"
                  :on-exceed="osg.uploadExceed"
                  :before-upload="
                    file => {
                      return osg.beforeUpload(file, 'image');
                    }
                  "
                  :on-success="
                    (response, file, fileList) => {
                      return uploadSuccess(fileList, item);
                    }
                  "
                  :on-error="osg.uploadError"
                  :on-remove="
                    (file, fileList) => {
                      item.img = '';
                      doSave();
                    }
                  "
                  :on-preview="osg.uploadPreview"
                >
                  <el-image
                    v-if="item.img"
                    style="width:100%;height:100%"
                    :src="item.img"
                    fit="cover"
                  />
                  <i v-else class="el-icon-plus"></i>
                </el-upload>
              </el-form-item>
              <div>
                <el-form-item label="名称">
                  <el-input v-model="item.name" @blur="doSave"></el-input>
                </el-form-item>
                <el-form-item label="类型">
                  <el-select
                    v-model="item.type"
                    @change="
                      delete item.typeId;
                      doSave();
                    "
                  >
                    <el-option
                      v-for="item in options.bannerType"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item style="margin-bottom:0" label="外链链接" v-if="item.type == 0">
                  <el-input v-model="item.typeId" @blur="doSave"></el-input>
                </el-form-item>
                <el-form-item style="margin-bottom:0" label="关联产品" v-if="item.type == 1">
                  <el-select
                    v-model="item.typeId"
                    clearable
                    filterable
                    :remote="true"
                    :remote-method="getProducts"
                    @change="doSave()"
                  >
                    <el-option
                      v-for="item in options.products"
                      :key="item._id"
                      :label="item.name"
                      :value="item._id"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </div>
            </div>
          </el-card>
        </el-form>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
export default {
  activated() {
    window.$this = this;
  },
  name: 'Config',
  data() {
    window.$this = this;
    return {
      options: {
        codecfg_bannerType: { codeId: 'bannerType' },
        products: []
      },
      formData: {
        banners: [{}]
      },
      upload: {
        url: 'http://up-z1.qiniup.com',
        downloadUrl: window.$this.osg.downloadUrl,
        data: {},
        fileList: [],
        dialogImageUrl: '',
        dialogVisible: false,
        limit: 1
      }
    };
  },
  mounted() {
    this.osg.codeoption(() => {
      this.getData();
      this.getProducts();
    });
  },
  methods: {
    getProducts(query) {
      this.osg.ajax(
        '/basic/product/query.do',
        {
          page: 1,
          rows: 10,
          'is:state|integer#and': 1,
          'is:productState|integer#and': 3,
          'regex:name|string#and': query
        },
        res => {
          this.options.products = res.data;
        },
        { noload: true }
      );
    },
    getData() {
      this.osg.ajax(
        '/mconfig/getConfig.do',
        {},
        res => {
          if (!res.data) {
            res.data = {
              banners: [{}]
            };
          } else {
            res.data.banners = res.data.banners || [{}];
            if (res.data.banners.length == 0) res.data.banners.push({});
          }
          this.formData = res.data;
        },
        {
          noload: true
        }
      );
    },
    doSave() {
      this.osg.ajax(
        'mconfig/upsert.do',
        this.formData,
        () => {
          this.getData();
        },
        {
          noload: true
        }
      );
    },
    add(i) {
      this.formData.banners.splice(i + 1, 0, { img: '', name: '', type: '', typeId: '' });
      this.doSave();
    },
    remove(i) {
      this.osg.confirm('是否确认删除？', () => {
        this.formData.banners.splice(i, 1);
        this.doSave();
      });
    },
    uploadSuccess(fileList, item) {
      this.$set(
        item,
        'img',
        window.$this.osg.downloadUrl == '/'
          ? fileList[fileList.length - 1].response.key
          : window.$this.osg.downloadUrl +
              fileList[fileList.length - 1].response.key.replace(window.$this.osg.downloadUrl, '')
      );
      this.doSave();
      return fileList;
    }
  }
};
</script>
<style scoped lang="scss">
.config {
  padding: 0 10px;
  ::v-deep .el-tabs__header {
    min-width: 150px;
  }
  ::v-deep .el-tabs__content {
    height: 100%;
    overflow-y: auto;
  }
  .c-card {
    max-width: 750px;
    margin-bottom: 15px;
    ::v-deep .el-card__header {
      padding: 10px;
      .c-card-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
    }
    ::v-deep .el-upload {
      width: 300px;
    }
  }
}
.c-m-b-15 {
  margin-bottom: 15px;
}
#app .el-form-item__content > div {
  width: 250px !important;
}
</style>
